import Point from "./Point.jsx";
import './styles/Poly.scss';
import protocolLogo from '../svg/protocol-logo.png';
import smartImg from '../svg/smart-img.png';


function Poly() {


    return (
        <section className="poly" id="features">
          <div className="polyText">
            <p className="desc1">
              <span className="subtitle colorLightBlue dBlock upText">
                Paribus
              </span>
              <span className="titleH2 dBlock">
                Features and Protocol
              </span>
              Paribus’ features and protocol is designed to evolve with
              new crypto asset classes, capturing the value stored in the
              emerging universe of interconnected blockchains.
              <br /><br />
              Our protocol sets out to channel this monetary energy in
              previously impossible ways, creating even more opportunity
              for investors.
            </p>
            <p className="desc1">
              <img
                src={protocolLogo}
                alt="smart image"
                className="smartImgProtocol"
              />
            </p>
          </div>
          <div className="polyContainer">
            <img
              src={smartImg}
              alt="smar image"
              className="smartImg"
            />
            <div className="points">
              <Point 
                  label="Lend, borrow or stake synthetic assets" 
                  desc="Increasing capital efficiency or investment flexibility,
                  across any chain."
              />
              <Point 
                  label="NFT collateral-based loans" 
                  desc="Borrow against your investment, freeing up your capital
                  while the underlying NFT appreciates in value."
              />
              <Point 
                  label="NFT Staking" 
                  desc="Pool value with other like-NFTs, earning yield on your
                  NFT assets."
              />
              <Point 
                  label="LP collateral-based loans" 
                  desc="Borrow against your AMM liquidity positions, allowing
                  you to leverage up while staking or earning through
                  LP’ing."
              />
              <Point 
                  label="LP staking" 
                  desc="Market specific staking pools for LP tokens from
                  multiple blockchain based liquidity pools."
              />
              <Point 
                  label="PBX token profit sharing" 
                  desc="Earn a percentage of fees collected by the network,
                  based on a tiered staking model."
              />
            </div>
          </div>
        </section>
    )
}
            
export default Poly;



